<template>
	<div class="">
		<div class="mx-auto max-w-7xl px-6">
			<div class="mx-auto max-w-4xl divide-y divide-gray-900/10">
				<h2 class="text-2xl font-googleBold text-gray-900 pb-6">Common Questions</h2>
				<dl class="space-y-6 divide-y divide-gray-900/10">
					<Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-4" v-slot="{ open }">
						<dt>
							<DisclosureButton class="flex w-full items-start justify-between text-left text-gray-900">
								<span class="text-base font-semibold leading-7">{{ faq.question }}</span>
								<span class="ml-6 flex h-7 items-center">

									<!-- Plus Icon -->
									<svg v-if="!open" class="h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
										<path fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
									</svg>

									<!-- Minus Icon -->
									<svg v-else class="h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
										<path fill-rule="evenodd" d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
									</svg>

								</span>
							</DisclosureButton>
						</dt>
						<DisclosurePanel as="dd" class="mt-2 pr-12">
							<p class="text-sm text-gray-600" v-html="faq.answer"></p>
						</DisclosurePanel>
					</Disclosure>
				</dl>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

const faqs = [
	{
		question: "How does this repository work?",
		answer:
			"When you authenticate with Google, you give SlideCub permission to programmatically access your Google Slide presentations. We start by creating a new folder on your Google Drive, with a new presentation that we\'ll use as a local repository. Each time you save a slide using the bookmarklet, we store a snapshot of that slide at that point in time to your personal repository. <br><br> On SlideCub, you\'ll be able to see all the slides you\'ve saved, regardless of what presentation they came from. You can sort and filter, and select slides to quickly generate new presentations, or insert specific slides into an existing presentation you have."
	},
	{
		question: "What permissions does SlideCub need from Google?",
		answer:
			"<ul>\n" +
			"    <li><strong>Google Slides:</strong> (<i>All Files - See, Edit, Create, Delete</i>): This permission allows SlideCub to read from the same presentations you can see without needing to explicitly request access each time. SlideCub will never delete a presentation, nor do we query for all presentations you have; we only access the presentations you explicitly tell us about using the bookmarklet.</li><br>" +
			"    <li><strong>Google Drive</strong> (<i>Specific Files - See, Edit, Create, Delete): </i>This permission allows SlideCub to create new folders in your Google Drive, as well as organize presentations that SlideCub creates to facilitate the repository feature. This permission does not grant SlideCub any access to any other files on your Drive.</li><br>" +
			"    <li><strong>Connect to an external Service</strong>: This permission allows SlideCub to run functions written within the Google Apps Script environment, which facilitates our ability to save slides, and generate new presentations. This is only necessary due to limitations in the existing Google Slides API, which require the use of Apps Script.</li>" +
			"</ul>"
	},
	{
		question: "What is a bookmarklet?",
		answer:
			"A bookmarklet is a browser bookmark that can execute code instead of opening a webpage. SlideCub uses a bookmarklet to allow you to save slides and can be used when viewing a Google Slides presentation."
	},
	{
		question: "Can I share the bookmarklet?",
		answer:
			"Your bookmarklet is generated with a code specific to your account on Google and SlideCub and should not be shared. The code itself is \"one way\" meaning that even if you do share the bookmarklet inadvertently, no one will be able to access your account."
	},
	{
		question: "What does the SlideCub bookmarklet do?",
		answer:
			"When clicked, your current URL is sent to SlideCub using an authentication code that allows us to match the request to your account. We can decode the URL to derive the Google Slides presentation you are currently looking at, as well as the current slide. It will request permissions to show you browser notifications which can notify you when a slide is successfully saved."
	},
	{
		question: "Can I share saved slides with my team?",
		answer:
			"Coming soon :)"
	},

]
</script>